import _ from 'lodash';
import { ActivePatient } from 'careand-redux/selectors';
import { deviceActions } from 'careand-redux/slices/device';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { useAppSelector } from 'careand-redux/store';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { Physician, PrimaryPhysicianSuggestion } from 'generated/api';
import React, { useEffect, useMemo, useState } from 'react';
import { getAccountSwitchPromise } from '../SwitchProfile/ConfirmationPopup';
import TopBar from '../TopBar';
import './style.scss';
import PhysicianUtils from 'services/PhysicianUtils';
import DefaultPopup from 'components/Utils/DefaultPopup';
import DefaultButton from 'components/Utils/NewDefaultButton';
import Icon from 'components/Utils/NewIcon';
import { api } from 'careand-redux/api/ApiThunks';
import { PhysicianImage, ProfileImage } from 'components/Common/UserImage';
import ChoosePrimaryPage from 'scenes/ChoosePrimary';

const DebugPage = () => {
  //@ts-expect-error
  return <ChoosePrimaryPage />;
};

export default DebugPage;
